import $ from 'jquery';

// ナビゲーションのアイテム数を計算&その他に格納
export const setNavigation = (frameWidth) => {
    const threthold = 767;

    if (threthold < frameWidth) {
        const navWidth = $('.l-nav').width();
        let listDisplayWidth = $('.l-nav__item--multi--other').outerWidth(true);

        $('.l-nav__list--other').html('');

        $('.l-nav__list')
            .children('.l-nav__item')
            .each((i, element) => {
                listDisplayWidth += $(element).outerWidth(true);
                if (navWidth <= listDisplayWidth) {
                    $(element)
                        .hide()
                        .clone()
                        .appendTo('.l-nav__list--other');
                } else {
                    $(element).show();
                }
            });

        // その他項目表示切替
        if ($('.l-nav__list--other .l-nav__item').length > 0) {
            $('.l-nav__item--multi--other')
                .show()
                .find('.l-nav__item')
                .show();
        } else {
            $('.l-nav__item--multi--other').hide();
        }
    }
};

$(() => {
    // ハンバーガーメニューの開閉
    $('#nav-trigger').on('click', () => {
        const $navi = $('.l-nav');
        $navi.toggleClass('is-active');
    });

    // メニュー表示中の背景click
    $('.l-nav-overlay').on('click', () => {
        $('#nav-trigger').click();
    });

    $(window).on('resize', () => {
        setNavigation(window.innerWidth);
    });
    setNavigation(window.innerWidth);
});
